import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Disclaimer() {
  return (
    <section className="relative py-28 bg-gradient-to-b from-[#0A2A66] via-[#133C91] to-[#0A2A66] text-white overflow-hidden">
      {/* Subtle mesh backdrop (same as Contact) */}
      <div className="pointer-events-none absolute inset-0 opacity-25 mix-blend-screen">
        <svg
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
        >
          <defs>
            <pattern
              id="meshGrid"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M40 0H0V40"
                fill="none"
                stroke="#ffffff"
                strokeOpacity="0.18"
                strokeWidth="1"
              />
            </pattern>
            <radialGradient id="rg" cx="35%" cy="25%" r="70%">
              <stop offset="0%" stopColor="#4bd3ff" stopOpacity="0.32" />
              <stop offset="100%" stopColor="#000" stopOpacity="0" />
            </radialGradient>
          </defs>
          <rect width="100%" height="100%" fill="url(#meshGrid)" />
          <rect width="100%" height="100%" fill="url(#rg)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 leading-relaxed">
        <motion.h1
          className="text-4xl md:text-5xl font-bold mb-10 text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Disclaimer
        </motion.h1>

        <motion.div
          className="space-y-6 text-white/90 text-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p>
            QuantNexusCapital provides access to non-custodial, smart
            contract–driven strategies designed for sophisticated allocators.
            The information presented on this website is for educational and
            informational purposes only. Nothing herein should be construed as
            financial, investment, tax, or legal advice.
          </p>

          <p>
            Past performance metrics, backtests, and live results displayed are
            not indicative of future outcomes. All investments carry risk,
            including the potential loss of principal. You acknowledge and
            accept full responsibility for your investment decisions and agree
            that QuantNexusCapital is not liable for any financial losses or
            damages arising from the use of our strategies or materials.
          </p>

          <p>
            Allocators are responsible for ensuring compliance with all
            applicable laws and regulations within their jurisdiction before
            engaging with our products. By interacting with our services, you
            confirm that you meet any local regulatory or eligibility
            requirements.
          </p>

          <p>
            QuantNexusCapital does not guarantee profits, safeguard against
            losses, or provide personalized investment recommendations. You
            should consult with a licensed financial advisor, tax professional,
            or legal counsel before making any investment decisions.
          </p>
        </motion.div>

        {/* Back to Home button */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-block px-6 py-3 rounded-xl bg-gradient-to-r from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white font-semibold shadow-lg transition"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Disclaimer;
